var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"height":"100%"}},[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('WidgetBoard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }